<app-access-manager [namespace]="PAGE_ACCESS_NAMESPACE">
<app-filterable-table
  #ordersTable
  [hidden]="selectedOrder != undefined"
  [tableView]="tableView"
  [options]="ordersTableOptions"
  [initialPageSize]="10"
  [title]="'Orders'"
>
</app-filterable-table>
</app-access-manager>